module.exports = __webpack_public_path__ + "media/images/icons-items-ed028a1c03182809893d375b37fb8f08.svg";